module.exports = __webpack_public_path__ + "static/media/CC20-LC230-12.1efcbc0d.png";